import React from "react";
import "./Navbar.css";
import MiniNavbar from "./MiniNavbar";
import BigNavbar from "./BigNavbar";
function Navbar(props) {
  return (
    <div className="main-navbar">
      <MiniNavbar setlangstate={props.setlangstate} user={props.user} />
      <div className="linebrk"></div>
      <BigNavbar setlangstate={props.setlangstate} user={props.user} />
    </div>
  );
}

export default Navbar;
